var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_229)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1643 35.2294C18.4372 35.2294 20.8165 36.3728 23.0791 38.5873C25.8121 42.0378 26.6704 44.9665 25.6301 47.284C23.3572 52.3551 12.7343 54.6245 6.29678 55.3833C7.37831 52.8014 8.64522 48.6058 8.64522 43.0507C8.64522 40.0156 10.7224 36.9427 13.579 35.7479C14.4133 35.4011 15.2819 35.2294 16.1643 35.2294ZM23.3332 30.0073C25.0224 30.9103 26.6601 32.0501 28.1811 33.554L28.6137 34.0415C29.4892 35.147 30.1965 36.2286 30.8145 37.2963C29.8909 38.1169 28.9433 38.9444 27.9785 39.7821C27.388 38.6731 26.6326 37.5332 25.7022 36.3659L25.5683 36.2148C24.0576 34.7247 22.4611 33.6089 20.8268 32.8707C21.6508 31.9128 22.4851 30.9584 23.3332 30.0073ZM56.036 4.90938C56.2798 5.15313 56.6025 5.5892 56.5647 6.54023C56.3759 11.4053 47.6792 21.9904 33.4238 34.9548C32.799 33.9454 32.1123 32.9291 31.3054 31.9094L30.6016 31.1197C29.0635 29.5987 27.4326 28.3421 25.7262 27.3361C36.6821 15.2782 48.4826 4.38751 54.1717 4.15401C55.1399 4.1506 55.5622 4.43557 56.036 4.90938ZM59.9947 6.67413C60.0599 4.99867 59.5312 3.54976 58.2402 2.25882C57.169 1.1876 55.6789 0.658885 54.0343 0.724135C44.517 1.11207 25.5271 22.0797 17.1737 31.8544C15.4982 31.6862 13.8399 31.9197 12.2537 32.5858C8.10963 34.3127 5.21184 38.6182 5.21184 43.0507C5.21184 51.4418 1.96387 56.3549 1.933 56.403L0 59.2733L3.44709 59.081C5.61013 58.9643 24.7374 57.6631 28.7647 48.6917C29.5269 46.9853 29.678 45.1553 29.2626 43.2154C40.9601 33.1591 59.641 15.7245 59.9947 6.67413Z",
    fill: "#FFF9C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiDesign);
export default __webpack_public_path__ + "static/media/ui_Design.c096e58c160d4b4f130f17adcf655460.svg";
export { ForwardRef as ReactComponent };